import React, { FC } from 'react';
import {
  AlertErrorSolid24,
  AlertErrorSolid32,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Amex,
  ApplePay,
  Chat,
  CheckIconGreen,
  CircleDisabled24,
  CircleDisabled32,
  CircleSelected24,
  CircleSelected32,
  CircleUnselected24,
  CircleUnselected32,
  Close24,
  Close32,
  DCPlay32,
  DCPause32,
  DisabledRadioIcon24,
  DisabledRadioIcon32,
  DisabledRadioIconV2,
  Discover,
  Error24,
  Error32,
  ErrorFilled24,
  ErrorFilled32,
  ErrorRedFilled,
  Feedback,
  Facebook24,
  Facebook32,
  FacebookCircle24,
  FacebookCircle32,
  FacebookOutlined24,
  FacebookOutlined32,
  FaqBopis1,
  FaqBopis2,
  FaqBopis3,
  ExpressCreditCard,
  Google24,
  Google32,
  GoogleCircle24,
  GoogleCircle32,
  GoogleOutlined24,
  GoogleOutlined32,
  Hanger24,
  Hanger32,
  Information24,
  Information32,
  Instagram24,
  Instagram32,
  InstagramCircle24,
  InstagramCircle32,
  InstagramOutlined24,
  InstagramOutlined32,
  Linkedin24,
  Linkedin32,
  Locator24,
  Locator32,
  Lock,
  Klarna,
  Pause24,
  Pause32,
  Paypal,
  PaypalCredit,
  Phone,
  Pinterest24,
  Pinterest32,
  PinterestCircle24,
  PinterestCircle32,
  PinterestOutlined24,
  PinterestOutlined32,
  Play24,
  Play32,
  PlayDisabled24,
  PlayDisabled32,
  PriceTag32,
  Return,
  ShippingTruck,
  ShipToHome24,
  ShipToHome32,
  ShoppingBag24,
  ShoppingBag32,
  Snapchat24,
  Snapchat32,
  SnapchatCircle24,
  SnapchatCircle32,
  SnapchatOutlined24,
  SnapchatOutlined32,
  Store24,
  Store32,
  StorePickup24,
  StorePickup32,
  Success24,
  Success32,
  SuccessFilled24,
  SuccessFilled32,
  Tiktok24,
  Tiktok32,
  Twitter24,
  Twitter32,
  TwitterCircle24,
  TwitterCircle32,
  TwitterOutlined24,
  TwitterOutlined32,
  Visa,
  Warning24,
  Warning32,
  WarningFilled24,
  WarningFilled32,
  WarningYellow,
  Youtube24,
  Youtube32,
  YoutubeCircle24,
  YoutubeCircle32,
  YoutubeOutlined24,
  YoutubeOutlined32,
  Birthday120,
  ShopTheLookBadge,
  EarlyAccess120,
  ReceiptlessReturns120,
  Rewards120,
  MasterCard,
  Sound32,
  Mute32,
  UnMute32,
} from './svg';

export interface IconV2Props extends React.ComponentPropsWithoutRef<'svg'> {
  icon?: IconV2IconNames;
  chroma?: string;
  className?: string;
  name?: IconV2IconNames;
  opacity?: string;
  size?: 'small' | 'large';
}

export type IconV2IconNames =
  | 'alert-error-solid'
  | 'americanExpress'
  | 'applePay'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'chat'
  | 'check-green'
  | 'circle-disabled'
  | 'circle-selected'
  | 'circle-unselected'
  | 'close'
  | 'dcplay'
  | 'dcpause'
  | 'disabled-radio-icon'
  | 'disabled-radio-icon-v2'
  | 'discover'
  | 'error'
  | 'error-filled'
  | 'error-red-filled'
  | 'expressCard'
  | 'facebook'
  | 'feedback'
  | 'facebook-circle'
  | 'facebook-outlined'
  | 'faq-bopis-1'
  | 'faq-bopis-2'
  | 'faq-bopis-3'
  | 'google'
  | 'google-circle'
  | 'google-outlined'
  | 'hanger'
  | 'information'
  | 'instagram'
  | 'instagram-circle'
  | 'instagram-outlined'
  | 'linkedin'
  | 'locator'
  | 'lock'
  | 'klarna'
  | 'masterCard'
  | 'mute'
  | 'pause'
  | 'paypal'
  | 'paypalCredit'
  | 'phone'
  | 'pinterest'
  | 'pinterest-circle'
  | 'pinterest-outlined'
  | 'play'
  | 'play-disabled'
  | 'price-tag'
  | 'return'
  | 'shipping-truck'
  | 'shipToHome'
  | 'shopping-bag'
  | 'snapchat'
  | 'shopTheLookBadge'
  | 'snapchat-circle'
  | 'snapchat-outlined'
  | 'sound'
  | 'store'
  | 'storePickup'
  | 'success'
  | 'success-filled'
  | 'tiktok'
  | 'twitter'
  | 'twitter-circle'
  | 'twitter-outlined'
  | 'visa'
  | 'warning'
  | 'warning-filled'
  | 'warning-yellow'
  | 'youtube'
  | 'youtube-circle'
  | 'youtube-outlined'
  | 'birthday'
  | 'earlyAccess'
  | 'receiptlessReturns'
  | 'rewards'
  | 'unmute';

export const svgs: Record<
  IconV2IconNames,
  {
    small?: React.FunctionComponent<IconV2Props>;
    large?: React.FunctionComponent<IconV2Props>;
  }
> = {
  'alert-error-solid': {
    small: AlertErrorSolid24,
    large: AlertErrorSolid32,
  },
  americanExpress: {
    small: Amex,
    large: Amex,
  },
  applePay: {
    small: ApplePay,
    large: ApplePay,
  },
  'arrow-down': {
    small: ArrowDown,
    large: ArrowDown,
  },
  'arrow-left': {
    small: ArrowLeft,
    large: ArrowLeft,
  },
  'arrow-right': {
    small: ArrowRight,
    large: ArrowRight,
  },
  chat: {
    small: Chat,
    large: Chat,
  },
  'check-green': {
    small: CheckIconGreen,
    large: CheckIconGreen,
  },
  'circle-disabled': {
    small: CircleDisabled24,
    large: CircleDisabled32,
  },
  'circle-selected': {
    small: CircleSelected24,
    large: CircleSelected32,
  },
  'circle-unselected': {
    small: CircleUnselected24,
    large: CircleUnselected32,
  },
  close: {
    small: Close24,
    large: Close32,
  },
  dcplay: {
    small: DCPlay32,
    large: DCPlay32,
  },
  dcpause: {
    small: DCPause32,
    large: DCPause32,
  },
  'disabled-radio-icon': {
    small: DisabledRadioIcon24,
    large: DisabledRadioIcon32,
  },
  'disabled-radio-icon-v2': {
    small: DisabledRadioIconV2,
    large: DisabledRadioIconV2,
  },
  discover: {
    small: Discover,
    large: Discover,
  },
  error: {
    small: Error24,
    large: Error32,
  },
  'error-filled': {
    small: ErrorFilled24,
    large: ErrorFilled32,
  },
  'error-red-filled': {
    small: ErrorRedFilled,
    large: ErrorRedFilled,
  },
  expressCard: {
    small: ExpressCreditCard,
    large: ExpressCreditCard,
  },
  facebook: {
    small: Facebook24,
    large: Facebook32,
  },
  feedback: {
    small: Feedback,
    large: Feedback,
  },
  'facebook-circle': {
    small: FacebookCircle24,
    large: FacebookCircle32,
  },
  'facebook-outlined': {
    small: FacebookOutlined24,
    large: FacebookOutlined32,
  },
  'faq-bopis-1': {
    small: FaqBopis1,
    large: FaqBopis1,
  },
  'faq-bopis-2': {
    small: FaqBopis2,
    large: FaqBopis2,
  },
  'faq-bopis-3': {
    small: FaqBopis3,
    large: FaqBopis3,
  },
  google: {
    small: Google24,
    large: Google32,
  },
  'google-circle': {
    small: GoogleCircle24,
    large: GoogleCircle32,
  },
  'google-outlined': {
    small: GoogleOutlined24,
    large: GoogleOutlined32,
  },
  hanger: {
    small: Hanger24,
    large: Hanger32,
  },
  information: {
    small: Information24,
    large: Information32,
  },
  instagram: {
    small: Instagram24,
    large: Instagram32,
  },
  'instagram-circle': {
    small: InstagramCircle24,
    large: InstagramCircle32,
  },
  'instagram-outlined': {
    small: InstagramOutlined24,
    large: InstagramOutlined32,
  },
  linkedin: {
    small: Linkedin24,
    large: Linkedin32,
  },
  locator: {
    small: Locator24,
    large: Locator32,
  },
  lock: {
    small: Lock,
    large: Lock,
  },
  klarna: {
    small: Klarna,
    large: Klarna,
  },
  masterCard: {
    small: MasterCard,
    large: MasterCard,
  },
  mute: {
    small: Mute32,
    large: Mute32,
  },
  pause: {
    small: Pause24,
    large: Pause32,
  },
  paypal: {
    small: Paypal,
    large: Paypal,
  },
  paypalCredit: {
    small: PaypalCredit,
    large: PaypalCredit,
  },
  phone: {
    small: Phone,
    large: Phone,
  },
  pinterest: {
    small: Pinterest24,
    large: Pinterest32,
  },
  'pinterest-circle': {
    small: PinterestCircle24,
    large: PinterestCircle32,
  },
  'pinterest-outlined': {
    small: PinterestOutlined24,
    large: PinterestOutlined32,
  },
  play: {
    small: Play24,
    large: Play32,
  },
  'play-disabled': {
    small: PlayDisabled24,
    large: PlayDisabled32,
  },
  'price-tag': {
    large: PriceTag32,
  },
  return: {
    small: Return,
    large: Return,
  },
  'shipping-truck': {
    small: ShippingTruck,
    large: ShippingTruck,
  },
  shipToHome: {
    small: ShipToHome24,
    large: ShipToHome32,
  },
  'shopping-bag': {
    small: ShoppingBag24,
    large: ShoppingBag32,
  },
  snapchat: {
    small: Snapchat24,
    large: Snapchat32,
  },
  shopTheLookBadge: {
    small: ShopTheLookBadge,
    large: ShopTheLookBadge,
  },
  'snapchat-circle': {
    small: SnapchatCircle24,
    large: SnapchatCircle32,
  },
  'snapchat-outlined': {
    small: SnapchatOutlined24,
    large: SnapchatOutlined32,
  },
  sound: {
    small: Sound32,
    large: Sound32,
  },
  store: {
    small: Store24,
    large: Store32,
  },
  storePickup: {
    small: StorePickup24,
    large: StorePickup32,
  },
  success: {
    small: Success24,
    large: Success32,
  },
  'success-filled': {
    small: SuccessFilled24,
    large: SuccessFilled32,
  },
  tiktok: {
    small: Tiktok24,
    large: Tiktok32,
  },
  twitter: {
    small: Twitter24,
    large: Twitter32,
  },
  'twitter-circle': {
    small: TwitterCircle24,
    large: TwitterCircle32,
  },
  'twitter-outlined': {
    small: TwitterOutlined24,
    large: TwitterOutlined32,
  },
  visa: {
    small: Visa,
    large: Visa,
  },
  warning: {
    small: Warning24,
    large: Warning32,
  },
  'warning-filled': {
    small: WarningFilled24,
    large: WarningFilled32,
  },
  'warning-yellow': {
    small: WarningYellow,
    large: WarningYellow,
  },
  youtube: {
    small: Youtube24,
    large: Youtube32,
  },
  'youtube-circle': {
    small: YoutubeCircle24,
    large: YoutubeCircle32,
  },
  'youtube-outlined': {
    small: YoutubeOutlined24,
    large: YoutubeOutlined32,
  },
  birthday: {
    small: Birthday120,
    large: Birthday120,
  },
  earlyAccess: {
    small: EarlyAccess120,
    large: EarlyAccess120,
  },
  receiptlessReturns: {
    small: ReceiptlessReturns120,
    large: ReceiptlessReturns120,
  },
  rewards: {
    small: Rewards120,
    large: Rewards120,
  },
  unmute: {
    small: UnMute32,
    large: UnMute32,
  },
};

const IconV2: FC<IconV2Props> = ({
  chroma = 'default',
  className,
  icon,
  name,
  opacity,
  size = 'large',
  ...otherProps
}) => {
  const svgIcon = icon as keyof typeof svgs;
  const svgSize = size as keyof (typeof svgs)[typeof svgIcon];
  const SVG = svgs[svgIcon] ? svgs[svgIcon][svgSize] : null;
  if (!SVG) {
    return null;
  } else {
    return (
      <SVG
        chroma={chroma}
        className={className}
        icon={icon}
        name={name}
        opacity={opacity}
        size={size}
        {...otherProps}
      />
    );
  }
};

IconV2.displayName = 'IconV2';

export default IconV2;
